import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCrewMembers } from '../../api/fetch-crew-members';

export const fetchCrewMembersThunk = createAsyncThunk(
    'fetchCrewMembers',
    async () => fetchCrewMembers(),
);
